// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./components/assets/Poppins/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./components/assets/Poppins/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./components/assets/landing_bg_img.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./components/assets/table.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: Poppins-bold;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
    font-family: Poppins;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

:root {
    --brand-primary: #0877BC;
    --brand-primary-dark: #065a8f;
    --brand-primary-light: #0a8cd8;
    --brand-secondary: #46528b;
    --brand-accent: #FFEFDD;
    --brand-bg: #f4f5f6;
    --brand-surface: #FFFFFF;
    --brand-text: #1E1E1E;
    --brand-text-secondary: #838383;
    --brand-font: 'Poppins', sans-serif;
    --brand-primary-rgb: 8, 119, 188;

    /* Dynamic Theme Mappings (bright / light is the default view) */
    --bg-color: var(--brand-bg, #f3f4f6);
    --surface-color: var(--brand-bg, #ffffff);
    --text-color: #111827;
    --text-secondary: #4b5563;
    --border-color: rgba(0, 0, 0, 0.08);
    --glass-bg: rgba(255, 255, 255, 0.85);
    --glass-border: rgba(0, 0, 0, 0.08);
    --shadow-color: rgba(0, 0, 0, 0.06);
    --card-hover-shadow: rgba(8, 119, 188, 0.15);
    --profile-hover-bg: rgba(0, 0, 0, 0.03);
    --profile-segmented-bg: rgba(0, 0, 0, 0.08);
    --ease-premium: cubic-bezier(0.16, 1, 0.3, 1);
}

.light-mode {
    --bg-color: var(--brand-bg, #f3f4f6);
    --surface-color: var(--brand-bg, #ffffff);
    --text-color: #111827;
    --text-secondary: #4b5563;
    --border-color: rgba(0, 0, 0, 0.08);
    --glass-bg: rgba(255, 255, 255, 0.85);
    --glass-border: rgba(0, 0, 0, 0.08);
    --shadow-color: rgba(0, 0, 0, 0.06);
    --card-hover-shadow: rgba(8, 119, 188, 0.15);
    --profile-hover-bg: rgba(0, 0, 0, 0.03);
    --profile-segmented-bg: rgba(0, 0, 0, 0.08);
}

/* Premium native-like iOS Start Button interactive transitions */
.ios-start-btn {
    transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1), filter 0.25s ease, box-shadow 0.25s ease !important;
}
.ios-start-btn:hover:not(:disabled) {
    filter: brightness(1.08);
    transform: translateY(-1.5px);
    box-shadow: 0 8px 22px rgba(var(--brand-primary-rgb), 0.45) !important;
}
.ios-start-btn:active:not(:disabled) {
    transform: scale(0.96) translateY(0);
    filter: brightness(0.95);
    box-shadow: 0 4px 10px rgba(var(--brand-primary-rgb), 0.25) !important;
}

.dark-mode {
    --bg-color: #0b0f19;
    --surface-color: #111827;
    --text-color: #f9fafb;
    --text-secondary: #9ca3af;
    --border-color: rgba(255, 255, 255, 0.08);
    --glass-bg: rgba(17, 24, 39, 0.75);
    --glass-border: rgba(255, 255, 255, 0.08);
    --shadow-color: rgba(0, 0, 0, 0.3);
    --card-hover-shadow: rgba(8, 119, 188, 0.25);
    --profile-hover-bg: rgba(255, 255, 255, 0.05);
    --profile-segmented-bg: rgba(255, 255, 255, 0.12);
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: var(--brand-font);
}

body {
    font-family: var(--brand-font);
    background-color: var(--bg-color);
    color: var(--text-color);
    transition: background-color 0.3s ease, color 0.3s ease;
}



#adminRoot {
    position: relative;
    min-height: 100vh;
    max-height: max-content;
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    color: #343339;
    margin: 0 auto;
    padding: 0 5px;
    /* Room for bottom nav + safe area so content is never hidden behind it */
    padding-bottom: max(120px, calc(80px + env(safe-area-inset-bottom)));
}

#adminRoot.home-theme-root,
#adminRoot.user-form-theme,
#adminRoot.group-form-theme {
    color: var(--text-color);
    background-color: var(--bg-color);
    transition: background-color 0.3s ease, color 0.3s ease;
}


.Hero::before {
    position: absolute;
    content: '';
    z-index: 0;
    width: 100%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: cover;
    background-repeat: no-repeat;
}

.rdrMonths {
    align-items: center
}

.Hero {
    overflow: hidden;
    object-fit: fill;
    width: 50%;
    height: 100vh;
    position: relative;

    >h1 {
        color: #FFF;
        text-align: center;
        font-size: 23px;
        font-style: normal;
        font-weight: 600;
        line-height: 29px;
        text-align: center;
        position: absolute;
        bottom: 20px;
        margin: 0;
        padding: 0 20px;
    }
}

.validation_error {
    font-size: 11px;
    color: red;
    margin-top: 7px;
}

.fgb-login>button {
    width: 100%;
}

.fbg-btn {
    >p {
        color: var(--neutral-1, #1E1E1E);
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
    }

}

.seperator {
    display: flex;
    flex-direction: row;
    align-items: center;
    /* 150% */

    >hr {
        height: 1px;
        border: none;
        background: #D9D9D9;
        width: 42.5vw;
    }

    >p {
        color: var(--Gray-1, #838383);
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        margin: 0 1vw;
    }
}

.hide {
    filter: invert(44%) sepia(90%) saturate(6420%) hue-rotate(187deg) brightness(93%) contrast(94%);
}

.search-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
}

.search-bar-input {
    width: 85%;
    display: flex;
    border-radius: 50px;
    padding: 12px;
    background: var(--surface-color);
    border: 1px solid var(--border-color);
    transition: all 0.3s var(--ease-premium);

    &:focus-within {
        border-color: var(--brand-primary);
        box-shadow: 0 0 10px rgba(var(--brand-primary-rgb), 0.2);
    }

    >img {
        margin-right: 5px;
        opacity: 0.7;
    }

    >input {
        background: none;
        border: none;
        color: var(--text-color);
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        width: 100%;
    }

    >input:focus-visible {
        outline: none;
    }
}

.filter-btn {
    background: none;
    border-radius: 50px;
    padding: 7px 8px;
    border: 1px solid var(--Line, #EDEDED);
}

.filter-btn:hover {
    opacity: .7;
}


.news-cards {
    margin: 10px 3vw 0 3vw;
}

.news-card {
    height: 178px;
    width: 100%;
    max-width: 370px;
    background-size: contain;
    border-radius: 8px;
    border-radius: 8px;
    position: relative;

    >.news-card-info {
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: self-start;
        position: absolute;
        bottom: 1vh;
        left: 3vw;

        >h3 {
            color: #FFF;
            /* Course Title */
            font-family: Poppins;
            font-size: 16px;
            font-style: normal;
            font-weight: 600;
            line-height: 24px;
            /* 150% */
        }

        >p {
            color: #939393;
            font-family: Poppins;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px;
            /* 171.429% */
        }
    }
}

.whitespace {
    height: 5vh;
}

.dot {
    background-color: var(--brand-primary) !important;
    width: 6px !important;
    height: 6px !important;
}

.news-info {
    margin-top: 10px;
}


.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;
    height: 50px;
    padding: 15px;

    >h2 {
        color: var(--Black, #202226);
        font-family: Poppins;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
        /* 120% */
    }
}

.progress-cards {
    display: flex;
    gap: 20px;
    padding: 15px;
    flex-wrap: wrap;
    align-items: stretch;
}

.progress-card {
    position: relative;
    height: auto;
    min-width: 140px;
    width: calc(50% - 10px);
    border-radius: 16px;
    background: var(--surface-color);
    border: 1px solid var(--border-color);
    box-shadow: 0px 4px 12px var(--shadow-color);
    padding: 12px;
    transition: transform 0.3s var(--ease-premium), box-shadow 0.3s var(--ease-premium), border-color 0.3s var(--ease-premium);

    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 10px 25px var(--card-hover-shadow);
        border-color: var(--brand-primary);
    }

    >.progress-card-header {
        padding: 6px;
        display: flex;
        justify-content: space-between;
        align-items: start;

        >h3 {
            color: var(--text-color);
            font-family: Poppins;
            font-size: 11px;
            font-style: normal;
            font-weight: 500;
            line-height: 16px;
        }

        >p {
            text-align: center;
            font-size: 18px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
            border-radius: 8px;
            background: rgba(var(--brand-primary-rgb), 0.15);
            color: var(--brand-primary);
            height: 40px;
            min-width: 40px;
            justify-content: center;
            display: flex;
            align-items: center;
        }
    }

    >img {
        display: flex;
        margin: auto;
        margin-bottom: 17px;
    }

}

.progress-card-data {
    >h3 {
        color: var(--text-color);
        font-family: Poppins-bold;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
    }

    >p {
        color: var(--text-secondary);
        font-family: Poppins-bold;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
}

.progress-card-data-center {
    width: 50px;
    position: absolute;
    top: 50%;
    left: 31%;
    text-align: center;
}

.progress-card-data-uncenter {
    margin: 17px 6px;
    display: flex;
    /* justify-content: baseline; */
    align-items: baseline;
}



.exercise-procedure-service-h3 {
    color: var(--Primary-Color, #0877BC);
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    /* 120% */
}

.exercise-procedure-service {
    width: 100%;
    height: 260px;
    background-size: contain;
    background-position: center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-repeat: no-repeat;
    background-position-y: -24px;
    margin-bottom: 40px;

    >h3 {
        color: var(--Primary-Color, #0877BC);
        font-family: Poppins;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
        /* 120% */
    }

    >.tabletop-sections {
        perspective: 50px;
        perspective-origin: top right;
        position: relative;
        top: 65px;
        left: max(-15vw, -22px);
        display: flex;
        justify-content: center;
        align-items: center;

        >div {
            transform: rotateX(10deg) rotateZ(11deg);
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: row-reverse;
            width: min(50vw, 129px);
            flex-wrap: wrap;

            >div {
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: var(--brand-secondary);
                width: min(16.667vw, 43px);
                height: min(18px, 7vw);
                border-bottom: #919191 .5px solid;
                border-right: #919191 .5px solid;
                color: #FFF;
                font-family: 'Poppins';
                font-size: 13px;
                font-style: normal;
                font-weight: 600;
                line-height: 24px;
                /* 184.615% */
            }
        }
    }
}


.exercise-details {
    display: flex;
    justify-content: start;
    padding: 15px;
    gap: 40px;

    >.edit-exercise-objective {
        >textarea {
            width: 100%;
            height: 80px;
            color: var(--Gray-1, #838383);
            font-family: Poppins;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px;
            /* 150% */
        }

        >p {
            color: var(--Gray-1, #838383);
            font-family: Poppins;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px;
            /* 150% */
        }

        >div {
            display: flex;
            align-items: center;
            gap: 10px;

            >span {
                margin-right: 3px;
                color: var(--Primary-Color, #0877BC);
                font-family: Poppins;
                font-size: 14px;
                font-style: normal;
                font-weight: 600;
                line-height: 24px;
                /* 171.429% */
            }

            >img {
                height: 20px;
                filter: brightness(0) saturate(100%) invert(26%) sepia(99%) saturate(1569%) hue-rotate(183deg) brightness(99%) contrast(94%);
            }
        }
    }

    >.exercise-details-show,
    >.exercise-details-edit {
        display: flex;
        flex-direction: column;
        gap: 7px;

        >span {
            color: var(--Primary-Color, #0877BC);
            font-family: Poppins;
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            line-height: 24px;
            /* 171.429% */
        }

        >p {
            color: var(--Gray-1, #838383);
            font-family: Poppins;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px;
            /* 200% */
        }

        >select {
            border: none;
            border-radius: 3px;
            background: rgba(var(--brand-primary-rgb), 0.17);
            color: var(--Primary-Color, #0877BC);
            font-family: Poppins;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px;
            /* 200% */
        }
    }
}

.exercise-details-skills {
    padding: 0 15px;

    >div {
        >span {
            color: var(--Primary-Color, #0877BC);
            font-family: Poppins;
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            line-height: 24px;
            /* 171.429% */
        }
    }

    >.add-skill {
        display: flex;
        justify-content: start;
        align-items: center;
        margin-top: 10px;

        >input {
            height: 28px;
            border-radius: 4px;
            border: none;
            margin-right: 5px;
            padding: 7px;
            background: rgba(var(--brand-primary-rgb), 0.17);
            color: var(--Primary-Color, #0877BC);
            font-family: Poppins;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px;
            /* 200% */
        }

        >input:focus-visible {
            outline: 1px cadetblue;
        }

        >button {
            border: none;
            border-radius: 4px;
            padding: 0 7px;
            background-color: rgba(var(--brand-primary-rgb), 0.17);
            color: var(--Primary-Color, #0877BC);
            font-family: Poppins;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px;
            /* 200% */
        }
    }
}

.exercise-details-skill-names {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 10px;

    >p {
        position: relative;
        color: var(--Primary-Color, #0877BC);
        font-family: Poppins;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        padding: 2px 7px;
        border-radius: 4px;
        background: var(--Primary-Color, #0877bc2d);
        /* 200% */

        >span {
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: -8px;
            right: -5px;
            height: 15px;
            width: 15px;
            border-radius: 8px;
            color: #FFF;
            background-color: var(--brand-primary);
        }
    }
}

.exercise-focus-points {
    display: flex;
    flex-direction: column;
    margin: 20px 0;
    gap: 7px;
    padding: 0 15px;

    >.edit-focus {
        display: flex;
        align-items: baseline;

        >h3 {
            color: #000;
            font-family: Poppins;
            font-size: 20px;
            font-style: normal;
            font-weight: 600;
            line-height: 24px;
            margin-bottom: 10px;
        }

        >img {
            height: 20px;
            filter: brightness(0) saturate(100%) invert(26%) sepia(99%) saturate(1569%) hue-rotate(183deg) brightness(99%) contrast(94%);
        }
    }

    >h3 {
        color: #000;
        font-family: Poppins;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
        margin-bottom: 10px;
        /* 120% */
    }

    >div {
        display: flex;
        gap: 6px;
        align-items: first baseline;

        >span {
            height: 6px;
            flex-shrink: 0;
            width: 6px;
            border-radius: 12px;
            background-color: var(--brand-primary);
        }

        >p {
            color: var(--Gray-1, #838383);
            font-family: Poppins;
            font-size: 11px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px;
            /* 145.455% */
        }

        >input {
            width: 100%;
        }

        >input:focus-visible {
            outline: none;
        }
    }
}

.exercise-procedure {
    padding: 15px;

    >h3 {
        color: #000;
        font-family: Poppins;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
        /* 120% */
        margin-bottom: 40px;
    }
}

.shot-details {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    bottom: -135px;
    justify-content: space-between;

    >div {
        display: flex;
        flex-direction: column;

        >span {
            color: var(--Primary-Color, #0877BC);
            font-family: Poppins;
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            line-height: 24px;
            /* 171.429% */
        }

        >p {
            color: var(--Gray-1, #838383);
            font-family: Poppins;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px;
            /* 200% */
        }

        >select {
            border: none;
            border-radius: 3px;
            background: rgba(var(--brand-primary-rgb), 0.17);
            color: var(--Primary-Color, #0877BC);
            font-family: Poppins;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px;
            /* 200% */
        }
    }
}

.tabletop-section-active {
    background-color: rgb(155, 75, 138) !important;
}

a {
    text-decoration: none;
}

.exercise-started {
    >video {
        margin: 0 3vw;
        width: 100%;
        border-radius: 8px;
    }
}

.exercise-header-white {
    margin: 20px 3vw;
    display: flex;
    justify-content: space-between;
    align-items: center;

    >h2 {
        color: #ffffff;
        font-family: Poppins-bold;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
        /* 120% */
    }

    >button {
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        height: 45px;
        width: 45px;
        border-radius: 50px;
        border: 1px solid var(--Line, #ffffff);
    }

    >button:hover {
        opacity: .7;
        box-shadow: 0px 5px 10px 0px rgba(234, 240, 246, 0.60);
    }

    >.back-btn {
        background-color: #0877bc00;

        >img {
            filter: brightness(0) saturate(100%) invert(100%) sepia(2%) saturate(0%) hue-rotate(135deg) brightness(104%) contrast(102%);
        }
    }

    >.fav-btn {
        background: none;

        >img {
            filter: brightness(0) saturate(100%) invert(100%) sepia(2%) saturate(0%) hue-rotate(135deg) brightness(104%) contrast(102%);
        }
    }
}

.exercise-page-details {
    width: 100%;
    display: flex;
    flex-direction: column;

    >button {
        gap: 5px;
        background: none;
        border: none;
        display: flex;
        /* justify-content: baseline; */
        align-items: center;
        margin: 8px 3vw;
        color: var(--Gray-1, #838383);
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        /* 171.429% */
        text-decoration-line: underline;
    }

    .button {
        width: 90%;
        background-color: var(--brand-primary);
        color: var(--White, #FFF);
        text-align: center;
        margin: 10px auto;
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        font-family: Poppins;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
        /* 150% */
    }
}

.exercise-name {
    /* overflow: hidden; */
    overflow-x: hidden;
    margin: 10px 3vw;
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* margin-top: 10px; */

        >button {
        background: none;
        border: none;
        width: 35px;
        height: 35px;
        border-radius: 50px;
        background: rgba(var(--brand-primary-rgb), 0.20);
    }

    >h3 {
        color: var(--Primary-Color, #0877BC);

        /* Heading */
        font-family: Poppins;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px;
        /* 140% */
    }
}

.exercise-step-info {
    color: var(--Gray-1, #838383);
    margin: 0 3vw;
    /* Body/Regular */
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    /* 171.429% */
}

.exercise-timer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

}

.timer-clock {
    color: var(--Black, #202226);
    text-align: center;
    font-family: Poppins-bold;
    font-size: 35px;
    font-style: normal;
    font-weight: 600;
    line-height: 46px;
    /* 131.429% */
}

.timer-actions {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin: 100px;

    >button {
        background: none;
        border: none;
    }

    >button:disabled {
        cursor: not-allowed;
    }
}

.pause-play {



    >img {
        cursor: pointer;
        width: 35px;
        filter: brightness(0) saturate(100%) invert(26%) sepia(98%) saturate(1262%) hue-rotate(180deg) brightness(104%) contrast(94%);
    }

}

.feedback-input {
    margin-top: 10px;

    h4 {
        color: var(--Black, #202226);
        font-family: Poppins;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px;
        /* 175% */
    }
}

.feedback-input-options {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin: 17px 0;
}

.feedback-input-option {
    border-radius: 8px;
    background: #FFF;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.13);
    width: 100px;
    height: 81px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    >p {
        color: #202226;
        text-align: center;
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
}

.feedback-input-option.selected {
    background: var(--Primary-Color, #0877BC);

    >p {
        color: #FFF;
    }
}


.add-exercise {
    padding: 25px 30px;
    width: 50%;
    max-width: 100%;
    margin: auto;
    border-radius: 16px;
    box-shadow: 0px 10px 30px var(--shadow-color);
    background-color: var(--surface-color);
    border: 1px solid var(--border-color);
    box-sizing: border-box;
    overflow-x: hidden;
    transition: all 0.3s var(--ease-premium);


    >button {
        height: 45px;
        margin-bottom: 3vw;
        color: #FFF;
        font-family: Poppins;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        border: none;
        border-radius: 8px;
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
        /* background-color: #0877BC; */
    }

    >button:hover {
        opacity: 0.7;
    }

}

.input {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: transparent;
    background: none;
    border-radius: 7px;
    /* opacity: 0.1; */

    background: rgba(var(--brand-primary-rgb), 0.09);
}

.input::-webkit-file-upload-button {
    visibility: hidden;
}


.input:hover::before {
    border-color: black;
}

.input:active {
    outline: 0;
}

.input:active::before {
    background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
}

.exercise-procedure-add {
    width: 100%;
    height: 260px;
    background-size: contain;
    background-position: center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-repeat: no-repeat;
    margin-bottom: 40px;

    >.tabletop-sections {
        perspective: 50px;
        perspective-origin: top right;
        position: relative;
        top: 65px;
        left: max(-15vw, -22px);
        display: flex;
        justify-content: center;
        align-items: center;

        >div {
            transform: rotateX(10deg) rotateZ(11deg);
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: row-reverse;
            width: min(50vw, 129px);
            flex-wrap: wrap;

            >div {
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: var(--brand-secondary);
                width: min(16.667vw, 43px);
                height: min(18px, 7vw);
                border-bottom: #919191 .5px solid;
                border-right: #919191 .5px solid;
                color: #FFF;
                font-family: 'Poppins';
                font-size: 13px;
                font-style: normal;
                font-weight: 600;
                line-height: 24px;
                /* 184.615% */
            }
        }
    }
}

.uploaded-picture {
    height: 260px;
    object-fit: contain;
}

.thumbs-wrapper {
    display: none;
}

.add-skill {
    >input {
        height: 30px;
        border: none;
        background-color: #F7F7F7;
        padding: 10px 10px;
        border-radius: 8px;
        color: #404145;
        font-family: Poppins;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;

    }

    >input:focus-visible {
        outline: none;
    }

    >button {
        color: var(--Primary-Color, #0877BC);
        font-family: Poppins;
        font-size: 12px;
        height: 30px;
        padding: 0 7px;
        margin-left: 10px;
        font-style: normal;
        font-weight: 400;
        border-radius: 4px;
        border: none;
        line-height: 24px;
        /* 200% */
        background-color: rgba(var(--brand-primary-rgb), 0.09);
    }
}

.input-detail {
    button.w-100 {
        width: 100%;
    }

    .skills-box {
        width: 80%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: end;
    }

    .skills-checkbox {
        display: flex;
        justify-content: flex-start;
        gap: 10px;
    }
}




#feedback {
    padding: 15px;
    display: flex;
    gap: 10px;
    flex-direction: column;
    position: fixed;
    bottom: 0px;
    width: calc(60% - 30px);
    z-index: 100000000;
    background-color: #f4f5f6;
}

#feedback input {
    height: 40px;
    width: 100%;
    border-radius: 25px;
    padding: 15px;
    background-color: #fff;
}

#feedback .microphone {
    background: var(--brand-primary);
    width: 42px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
}

#feedback svg {
    color: #FFFFFF;
}

.audio-recorder {
    background: var(--brand-primary) !important;
}

#comments {
    width: 100%;
    padding: 15px;
    height: 70vh;
    overflow-y: scroll;

}

#comments::-webkit-scrollbar {
    width: 3px
}


/* Track */
#comments::-webkit-scrollbar-track {
    background: #f1f1f1;
}

/* Handle */
#comments::-webkit-scrollbar-thumb {
    background: #888;
}




#comments ul li .audioFeedback {
    width: 50%;
}

.author div {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid var(--brand-primary);
    background-color: #ccc;
    color: var(--brand-primary);
    text-align: center;
    padding: 0;

}

.author img {
    width: 30px;
    border-radius: 50%;
}

#saveChanges {
    padding: 0 15px;
    width: 100%;
}

#saveChanges button,
#saveChanges a {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 59px;
    border: none;
    color: var(--White, #FFF);
    text-align: center;
    leading-trim: both;
    text-edge: cap;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    border-radius: 12px;
    background: var(--Primary-Color, #0877BC);
    margin-bottom: 15px;
    width: 100%;
}

.session-setup {
    padding: 0 15px;
}

.session-setup ul {
    list-style-type: none;
    display: flex;
    flex-direction: column;
}

.session-setup ul li {
    display: flex;
    border: 1px solid #e3e3e3;
    border-radius: 8px;
    margin-bottom: 10px;
    padding: 8px;
    gap: 15px;
}

.session-setup ul li .image {
    width: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.session-setup ul li .image img {
    width: 100%;
}

.session-setup ul li .info {
    font-size: 14px;
    width: 60%;
}

.session-setup ul li .info h5 {}

.session-setup ul li .info p {}

.session-setup ul li select {
    border: none;
    border-radius: 3px;
    background: rgba(var(--brand-primary-rgb), 0.17);
    color: var(--Primary-Color, #0877BC);
    font-family: Poppins;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
}


#rating {
    padding: 15px;
}

#rating h1 {
    font-size: 16px;
    padding: 0;
    margin: 0;
    font-family: Poppins-bold;
}

#rating ul {
    list-style-type: none;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    margin-top: 15px;
}

#rating ul li {
    width: 33%;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    position: relative;
}

#rating ul li input[type="radio"] {
    display: none;
}

#rating ul li label {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
}

#rating ul li input[type="radio"]:checked+label {
    background: #0877BC;
    /* Change the border color to indicate the checked state */
}

#rating ul li input[type="radio"]:checked+label img {
    opacity: 0.8;
    /* Slightly fade the image for the checked state */
}

#rating ul li img {
    width: 65px;
}

#wavePlayerBtn {
    position: absolute;
    top: 30px;
    left: -45px;
    width: 40px;
    height: 40px;
    background: #000;
    border: 0;
    border-radius: 50%;
}

#wavePlayerBtn svg {
    color: #FFFFFF;
    width: 20px;
    height: 20px;
}

#dashLink {
    border: 1px solid #e3e3e3;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 505%;
    width: 41px;
    height: 42px;
    padding: 10px;
}


#selectedSessionDays {
    list-style-type: none;
    display: flex;
    flex-direction: row;
    gap: 10px;
    width: 100%;
    flex-wrap: wrap;
}

#selectedSessionDays button {
    position: relative;
    color: var(--text-color);
    font-family: Poppins;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    padding: 4px 12px;
    border-radius: 8px;
    background: var(--surface-color);
    border: 1px solid var(--border-color);
    text-transform: capitalize;
    margin-bottom: 10px;
    transition: all 0.2s var(--ease-premium);
}

#selectedSessionDays button:hover {
    background: var(--brand-primary);
    color: #fff;
    border-color: var(--brand-primary-light);
}

#selectedSessionDays span {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -8px;
    right: -5px;
    height: 15px;
    width: 15px;
    border-radius: 8px;
    color: #FFF;
    background-color: var(--brand-primary);
}

.sessionPlayers {}

.sessionPlayers select {
    border: none;
    border-radius: 3px;
    background: rgba(var(--brand-primary-rgb), 0.17);
    color: var(--brand-primary);
    font-family: Poppins;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 35%;
    height: 25px;
}

#permissions {}

#permissions th,
#permissions td {
    padding: 8px !important;
}

#timerAbsolute {}

/* --------------not use-------------------- */

.training-cards {
    display: flex;
    overflow-x: auto;
    overflow-y: auto;
    margin: 10px 3vw;
    gap: 12px;
}

.training-card {
    >img {
        width: 240px;
        height: 160px;
        object-fit: cover;
        object-position: 100% 50%;
        border-radius: 8px;
    }

    >h3 {
        color: #0A0615;
        font-family: Poppins;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
        /* 125% */
    }

    >.training-card-info {
        display: flex;
        align-items: center;
        gap: 6px;

        >.training-card-info-datetime {
            color: var(--Primary-Color, #0877BC);
            font-family: Poppins;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px;
            /* 200% */
        }

        >.training-card-info-duration {
            color: #404B52;
            font-family: Poppins;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px;
            /* 150% */
        }

        >span {
            height: 4px;
            width: 4px;
            background-color: #404B52;
            border-radius: 4px;
        }
    }
}


.other-training-card {
    display: flex;
    /* justify-content: center; */
    align-items: center;
    margin: 0 3vw 16px 3vw;
    height: 80px;
    padding: 8px;
    border-radius: 8px;
    border: 1px solid #E5E9EF;
    background: #FFF;

    >.other-training-card-img {
        height: 64px;
        width: 64px;
        border-radius: 8px;
    }

    >.other-training-card-info-svg {
        margin-left: auto;
    }

    .other-training-card-info {
        margin-left: 10px;

        >h3 {
            color: #0A0615;
            font-family: Poppins;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 20px;
            /* 125% */
        }

        >div {
            display: flex;
            align-items: center;

            >.duration {
                color: #404B52;
                font-family: Poppins;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 24px;
                margin-right: 10px;
                /* 171.429% */
            }

            >.datetime {
                color: var(--Primary-Color, #0877BC);
                font-family: Poppins;
                font-size: 12px;
                font-style: normal;
                font-weight: 500;
                line-height: 24px;
                /* 200% */
            }
        }
    }
}

.other-training-card:hover {
    background: var(--Primary-Color, #0877BC);

    >.other-training-card-info-svg {
        filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(317deg) brightness(103%) contrast(102%);
    }

    .other-training-card-info {
        >h3 {
            color: #FFF;
        }

        >div {
            >.duration {
                color: #D2D2D2;
            }

            >.datetime {
                color: var(--White, #FFF);
            }
        }
    }
}

/* Wrapper for pages under bottom nav: reserve space so content is not hidden behind the fixed bar */
.main-content-with-bottom-nav {
    padding-bottom: calc(96px + env(safe-area-inset-bottom, 0px));
    min-height: 0;
    display: block;
    width: 100%;
    max-width: 100%;
    overflow-x: clip;
    box-sizing: border-box;
}

/* Admin dashboard shell scrolls inside #content at 100vh — padding on the outer
   wrapper alone is not enough; clear the floating bottom nav inside the scroller. */
.main-content-with-bottom-nav #content {
    height: 100dvh;
    max-height: 100dvh;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding-bottom: calc(132px + env(safe-area-inset-bottom, 0px));
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
}

.main-content-with-bottom-nav #dashboard.admin-theme-root {
    min-height: 0;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow-x: clip;
}

html.lt-route-active .bottom-nav,
html.lt-immersive .bottom-nav,
html.lt-player-live .bottom-nav,
html.cm-immersive .bottom-nav {
    display: none !important;
    pointer-events: none;
}

html.lt-route-active .main-content-with-bottom-nav,
html.lt-immersive .main-content-with-bottom-nav,
html.cm-immersive .main-content-with-bottom-nav {
    padding-bottom: 0 !important;
}

/* Single bottom inset for shell pages — avoid stacking with #adminRoot / home-theme offsets */
.main-content-with-bottom-nav #adminRoot {
    padding-bottom: 0 !important;
    min-height: 0 !important;
    max-height: none;
}

.main-content-with-bottom-nav .home-theme-root {
    min-height: 0 !important;
    padding-bottom: 0 !important;
}

html.app-bottom-nav-shell,
html.app-bottom-nav-shell body {
    overscroll-behavior-y: none;
}

/* Extra bottom space for exercise list pages (SelectExerciseType, etc.) so last items stay above the nav */
.main-content-with-bottom-nav .exercise_session_div {
    padding-bottom: calc(100px + env(safe-area-inset-bottom, 0px));
}

.bottom-nav {
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: fixed;
    z-index: 999;
    bottom: calc(16px + env(safe-area-inset-bottom, 0px));
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 32px);
    max-width: 440px;
    padding: 10px 18px;
    background: var(--glass-bg, rgba(255, 255, 255, 0.76));
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid var(--border-color, rgba(255, 255, 255, 0.5));
    border-radius: 24px;
    box-shadow: 0 12px 36px var(--shadow-color, rgba(0, 0, 0, 0.12)), 
                0 4px 12px rgba(0, 0, 0, 0.04);
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.bottom-nav:has(> :nth-child(6)) {
    padding: 10px 12px;
    gap: 2px;
}

.bottom-nav-icon-mask {
    display: block;
    width: 22px;
    height: 22px;
    margin: 0 auto;
    background-color: var(--text-secondary, #838383);
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    -webkit-mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.bottom-nav-link {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border-radius: 50%;
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    width: 44px;
    height: 44px;
    text-align: center;
    box-sizing: border-box;
    color: var(--text-secondary, #4b5563);

    >svg {
        width: 22px;
        height: 22px;
        transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
        display: block;
        margin: 0 auto;
        color: currentColor;
        fill: currentColor;
    }
}

.bottom-nav-link:hover {
    background-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.06);
    transform: translateY(-4px) scale(1.05);
}

.bottom-nav-link:active {
    transform: translateY(-1px) scale(0.95);
    transition: all 0.1s ease;
}

/* Active tab style - sleek brand-colored pill with a gorgeous drop shadow glow */
.bottom-nav-link.active,
.bottom-nav>.active {
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, var(--brand-primary, #0877BC) 0%, var(--brand-primary-dark, #065a8f) 100%);
    transform: translateY(-6px) scale(1.1);
    border-radius: 50%;
    width: 48px;
    height: 48px;
    padding: 0;
    text-align: center;
    box-sizing: border-box;
    color: #ffffff;
    box-shadow: 0 8px 20px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);

    > .bottom-nav-icon-mask {
        width: 24px;
        height: 24px;
        background-color: #ffffff;
    }

    >svg {
        width: 24px;
        height: 24px;
        display: block;
        margin: 0 auto;
        color: #ffffff;
        fill: currentColor;
    }
}

.bottom-nav > button.bottom-nav-link {
    appearance: none;
    border: none;
    background: transparent;
    cursor: pointer;
    font: inherit;
    color: var(--text-secondary, #4b5563);
}

/* Button tabs (dashboard gear, live training) share .bottom-nav-link, but this
   reset is more specific than .bottom-nav-link.active. Without the override the
   selected gear stays white on the glass bar and disappears in bright mode. */
.bottom-nav > button.bottom-nav-link:hover:not(.active) {
    background-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.06);
}

.bottom-nav > button.bottom-nav-link.active,
.bottom-nav > button.bottom-nav-link.active:hover,
html.light-mode .bottom-nav > button.bottom-nav-link.active,
html.dark-mode .bottom-nav > button.bottom-nav-link.active {
    background: linear-gradient(135deg, var(--brand-primary, #0877BC) 0%, var(--brand-primary-dark, #065a8f) 100%);
    color: #ffffff;
}

.bottom-nav > button.bottom-nav-link.active > svg,
html.light-mode .bottom-nav > button.bottom-nav-link.active > svg,
html.dark-mode .bottom-nav > button.bottom-nav-link.active > svg {
    color: #ffffff;
    fill: currentColor;
}

html.light-mode .bottom-nav-link,
html.dark-mode .bottom-nav-link,
html.light-mode .bottom-nav > button.bottom-nav-link:not(.active),
html.dark-mode .bottom-nav > button.bottom-nav-link:not(.active) {
    color: var(--text-secondary);
}

html.light-mode .bottom-nav-icon-mask,
html.dark-mode .bottom-nav-icon-mask {
    background-color: var(--text-secondary);
}

.bottom-nav-link--live {
    position: relative;
}

.bottom-nav-live-dot {
    position: absolute;
    top: 7px;
    right: 7px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #22c55e;
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55);
    animation: lt-nav-pulse 1.6s ease-out infinite;
}

@keyframes lt-nav-pulse {
    0% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55); }
    70% { box-shadow: 0 0 0 8px rgba(34, 197, 94, 0); }
    100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }
}

.bottom-nav-link--live:disabled {
    opacity: 0.55;
    cursor: wait;
}

@media(max-width:1250px) {
    #feedback {
        width: calc(50% - 30px);
    }
}

@media(max-width:900px) {
    .Hero {
        width: 100%;
    }
}

@media(max-width:720px) {
    #feedback {
        background-color: #f4f5f6;
        width: 100%
    }
}

/* Add Exercise / Use Template row - fit on mobile */
.exercise-add-buttons-row {
    padding: 0 5px;
    box-sizing: border-box;
}

.exercise-add-buttons-row .exercise-add-btn {
    box-sizing: border-box;
    overflow: hidden;
    gap: 12px;
    padding: 10px 12px;
}

/* Keep text inside button - shrink text area, not icon.
   Parent row uses brand primary/secondary as full button bg; icon well must not
   stay fixed blue (Session.css .session-image-add) — use frosted chip on top. */
.exercise-add-buttons-row .exercise-add-btn .session-image-add {
    flex-shrink: 0;
    width: 44px;
    min-width: 44px;
    background-color: rgba(255, 255, 255, 0.22) !important;
    border: 2px solid rgba(255, 255, 255, 0.38);
    box-sizing: border-box;
}

.exercise-add-buttons-row .exercise-add-btn .session-addinfo {
    flex: 1 1;
    min-width: 0;
    overflow: hidden;
    padding-right: 0;
}

.exercise-add-buttons-row .exercise-add-btn .session-addinfo h3 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    line-height: 1.2;
    margin: 0;
}

@media (max-width: 480px) {
    .exercise-add-buttons-row {
        gap: 10px;
        padding: 0 8px;
        margin-bottom: 16px;
    }

    .exercise-add-buttons-row .exercise-add-btn {
        min-width: 0;
        flex-grow: 1;
        flex-shrink: 1;
        flex-basis: calc(50% - 10px);
        max-width: calc(50% - 5px);
        gap: 8px;
        padding: 8px 10px;
    }

    .exercise-add-buttons-row .exercise-add-btn .session-addinfo h3 {
        font-size: 12px;
    }
}

@media(max-width:500px) {
    .bottom-nav {
        justify-content: space-between;
    }

    .session-setup {
        padding: 0 10px;
    }

    .add-exercise {
        width: 100%
    }

    .progress-card {
        width: 100% !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,4CAA4D;AAChE;;AAEA;IACI,oBAAoB;IACpB,4CAA2D;AAC/D;;AAEA;IACI,wBAAwB;IACxB,6BAA6B;IAC7B,8BAA8B;IAC9B,0BAA0B;IAC1B,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;IACxB,qBAAqB;IACrB,+BAA+B;IAC/B,mCAAmC;IACnC,gCAAgC;;IAEhC,gEAAgE;IAChE,oCAAoC;IACpC,yCAAyC;IACzC,qBAAqB;IACrB,yBAAyB;IACzB,mCAAmC;IACnC,qCAAqC;IACrC,mCAAmC;IACnC,mCAAmC;IACnC,4CAA4C;IAC5C,uCAAuC;IACvC,2CAA2C;IAC3C,6CAA6C;AACjD;;AAEA;IACI,oCAAoC;IACpC,yCAAyC;IACzC,qBAAqB;IACrB,yBAAyB;IACzB,mCAAmC;IACnC,qCAAqC;IACrC,mCAAmC;IACnC,mCAAmC;IACnC,4CAA4C;IAC5C,uCAAuC;IACvC,2CAA2C;AAC/C;;AAEA,iEAAiE;AACjE;IACI,8GAA8G;AAClH;AACA;IACI,wBAAwB;IACxB,6BAA6B;IAC7B,sEAAsE;AAC1E;AACA;IACI,oCAAoC;IACpC,wBAAwB;IACxB,sEAAsE;AAC1E;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,qBAAqB;IACrB,yBAAyB;IACzB,yCAAyC;IACzC,kCAAkC;IAClC,yCAAyC;IACzC,kCAAkC;IAClC,4CAA4C;IAC5C,6CAA6C;IAC7C,iDAAiD;AACrD;;AAEA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,iCAAiC;IACjC,wBAAwB;IACxB,uDAAuD;AAC3D;;;;AAIA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,cAAc;IACd,yEAAyE;IACzE,oEAAoE;AACxE;;AAEA;;;IAGI,wBAAwB;IACxB,iCAAiC;IACjC,uDAAuD;AAC3D;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,YAAY;IACZ,yDAA6D;IAC7D,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,kBAAkB;;IAElB;QACI,WAAW;QACX,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;QAClB,kBAAkB;QAClB,YAAY;QACZ,SAAS;QACT,eAAe;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,gCAAgC;QAChC,kBAAkB;QAClB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;IACrB;;AAEJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;;IAET;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,6BAA6B;QAC7B,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,aAAa;IACjB;AACJ;;AAEA;IACI,+FAA+F;AACnG;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,gCAAgC;IAChC,qCAAqC;IACrC,wCAAwC;;IAExC;QACI,kCAAkC;QAClC,wDAAwD;IAC5D;;IAEA;QACI,iBAAiB;QACjB,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,wBAAwB;QACxB,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;;IAElB;QACI,aAAa;QACb,sBAAsB;QACtB,sBAAsB;QACtB,uBAAuB;QACvB,kBAAkB;QAClB,WAAW;QACX,SAAS;;QAET;YACI,WAAW;YACX,iBAAiB;YACjB,oBAAoB;YACpB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;YACjB,SAAS;QACb;;QAEA;YACI,cAAc;YACd,oBAAoB;YACpB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;YACjB,aAAa;QACjB;IACJ;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iDAAiD;IACjD,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,aAAa;;IAEb;QACI,4BAA4B;QAC5B,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,SAAS;IACb;AACJ;;AAEA;IACI,aAAa;IACb,SAAS;IACT,aAAa;IACb,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,gCAAgC;IAChC,qCAAqC;IACrC,4CAA4C;IAC5C,aAAa;IACb,0HAA0H;;IAE1H;QACI,2BAA2B;QAC3B,gDAAgD;QAChD,kCAAkC;IACtC;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,8BAA8B;QAC9B,kBAAkB;;QAElB;YACI,wBAAwB;YACxB,oBAAoB;YACpB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;QACrB;;QAEA;YACI,kBAAkB;YAClB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;YACjB,kBAAkB;YAClB,gDAAgD;YAChD,2BAA2B;YAC3B,YAAY;YACZ,eAAe;YACf,uBAAuB;YACvB,aAAa;YACb,mBAAmB;QACvB;IACJ;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,mBAAmB;IACvB;;AAEJ;;AAEA;IACI;QACI,wBAAwB;QACxB,yBAAyB;QACzB,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,4BAA4B;QAC5B,yBAAyB;QACzB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,+BAA+B;IAC/B,qBAAqB;AACzB;;;;AAIA;IACI,oCAAoC;IACpC,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,wBAAwB;IACxB,2BAA2B;IAC3B,yDAAsD;IACtD,4BAA4B;IAC5B,4BAA4B;IAC5B,mBAAmB;;IAEnB;QACI,oCAAoC;QACpC,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,iBAAiB;QACjB,6BAA6B;QAC7B,kBAAkB;QAClB,SAAS;QACT,uBAAuB;QACvB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;;QAEnB;YACI,wCAAwC;YACxC,aAAa;YACb,uBAAuB;YACvB,mBAAmB;YACnB,2BAA2B;YAC3B,uBAAuB;YACvB,eAAe;;YAEf;gBACI,aAAa;gBACb,uBAAuB;gBACvB,mBAAmB;gBACnB,wCAAwC;gBACxC,0BAA0B;gBAC1B,sBAAsB;gBACtB,iCAAiC;gBACjC,gCAAgC;gBAChC,WAAW;gBACX,sBAAsB;gBACtB,eAAe;gBACf,kBAAkB;gBAClB,gBAAgB;gBAChB,iBAAiB;gBACjB,aAAa;YACjB;QACJ;IACJ;AACJ;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,SAAS;;IAET;QACI;YACI,WAAW;YACX,YAAY;YACZ,6BAA6B;YAC7B,oBAAoB;YACpB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;YACjB,SAAS;QACb;;QAEA;YACI,6BAA6B;YAC7B,oBAAoB;YACpB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;YACjB,SAAS;QACb;;QAEA;YACI,aAAa;YACb,mBAAmB;YACnB,SAAS;;YAET;gBACI,iBAAiB;gBACjB,oCAAoC;gBACpC,oBAAoB;gBACpB,eAAe;gBACf,kBAAkB;gBAClB,gBAAgB;gBAChB,iBAAiB;gBACjB,aAAa;YACjB;;YAEA;gBACI,YAAY;gBACZ,4HAA4H;YAChI;QACJ;IACJ;;IAEA;;QAEI,aAAa;QACb,sBAAsB;QACtB,QAAQ;;QAER;YACI,oCAAoC;YACpC,oBAAoB;YACpB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;YACjB,aAAa;QACjB;;QAEA;YACI,6BAA6B;YAC7B,oBAAoB;YACpB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;YACjB,SAAS;QACb;;QAEA;YACI,YAAY;YACZ,kBAAkB;YAClB,gDAAgD;YAChD,oCAAoC;YACpC,oBAAoB;YACpB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;YACjB,SAAS;QACb;IACJ;AACJ;;AAEA;IACI,eAAe;;IAEf;QACI;YACI,oCAAoC;YACpC,oBAAoB;YACpB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;YACjB,aAAa;QACjB;IACJ;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,gBAAgB;;QAEhB;YACI,YAAY;YACZ,kBAAkB;YAClB,YAAY;YACZ,iBAAiB;YACjB,YAAY;YACZ,gDAAgD;YAChD,oCAAoC;YACpC,oBAAoB;YACpB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;YACjB,SAAS;QACb;;QAEA;YACI,sBAAsB;QAC1B;;QAEA;YACI,YAAY;YACZ,kBAAkB;YAClB,cAAc;YACd,sDAAsD;YACtD,oCAAoC;YACpC,oBAAoB;YACpB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;YACjB,SAAS;QACb;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;;IAEhB;QACI,kBAAkB;QAClB,oCAAoC;QACpC,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,kBAAkB;QAClB,2CAA2C;QAC3C,SAAS;;QAET;YACI,aAAa;YACb,uBAAuB;YACvB,mBAAmB;YACnB,kBAAkB;YAClB,SAAS;YACT,WAAW;YACX,YAAY;YACZ,WAAW;YACX,kBAAkB;YAClB,WAAW;YACX,sCAAsC;QAC1C;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,QAAQ;IACR,eAAe;;IAEf;QACI,aAAa;QACb,qBAAqB;;QAErB;YACI,WAAW;YACX,oBAAoB;YACpB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;YACjB,mBAAmB;QACvB;;QAEA;YACI,YAAY;YACZ,4HAA4H;QAChI;IACJ;;IAEA;QACI,WAAW;QACX,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,mBAAmB;QACnB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,QAAQ;QACR,2BAA2B;;QAE3B;YACI,WAAW;YACX,cAAc;YACd,UAAU;YACV,mBAAmB;YACnB,sCAAsC;QAC1C;;QAEA;YACI,6BAA6B;YAC7B,oBAAoB;YACpB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;YACjB,aAAa;QACjB;;QAEA;YACI,WAAW;QACf;;QAEA;YACI,aAAa;QACjB;IACJ;AACJ;;AAEA;IACI,aAAa;;IAEb;QACI,WAAW;QACX,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,SAAS;QACT,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,8BAA8B;;IAE9B;QACI,aAAa;QACb,sBAAsB;;QAEtB;YACI,oCAAoC;YACpC,oBAAoB;YACpB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;YACjB,aAAa;QACjB;;QAEA;YACI,6BAA6B;YAC7B,oBAAoB;YACpB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;YACjB,SAAS;QACb;;QAEA;YACI,YAAY;YACZ,kBAAkB;YAClB,gDAAgD;YAChD,oCAAoC;YACpC,oBAAoB;YACpB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;YACjB,SAAS;QACb;IACJ;AACJ;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,aAAa;QACb,WAAW;QACX,kBAAkB;IACtB;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;;IAEnB;QACI,cAAc;QACd,yBAAyB;QACzB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,YAAY;QACZ,YAAY;QACZ,WAAW;QACX,mBAAmB;QACnB,sCAAsC;IAC1C;;IAEA;QACI,WAAW;QACX,sDAAsD;IAC1D;;IAEA;QACI,2BAA2B;;QAE3B;YACI,2HAA2H;QAC/H;IACJ;;IAEA;QACI,gBAAgB;;QAEhB;YACI,2HAA2H;QAC/H;IACJ;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;;IAEtB;QACI,QAAQ;QACR,gBAAgB;QAChB,YAAY;QACZ,aAAa;QACb,+BAA+B;QAC/B,mBAAmB;QACnB,eAAe;QACf,6BAA6B;QAC7B,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,aAAa;QACb,+BAA+B;IACnC;;IAEA;QACI,UAAU;QACV,sCAAsC;QACtC,yBAAyB;QACzB,kBAAkB;QAClB,iBAAiB;QACjB,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,kBAAkB;QAClB,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,SAAS;IACb;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;;QAElB;QACA,gBAAgB;QAChB,YAAY;QACZ,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,gDAAgD;IACpD;;IAEA;QACI,oCAAoC;;QAEpC,YAAY;QACZ,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,SAAS;IACb;AACJ;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;;AAE3B;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;;IAEb;QACI,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;;;;IAII;QACI,eAAe;QACf,WAAW;QACX,6HAA6H;IACjI;;AAEJ;;AAEA;IACI,gBAAgB;;IAEhB;QACI,4BAA4B;QAC5B,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,SAAS;IACb;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gDAAgD;IAChD,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;;IAEnB;QACI,cAAc;QACd,kBAAkB;QAClB,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;IACvB;AACJ;;AAEA;IACI,yCAAyC;;IAEzC;QACI,WAAW;IACf;AACJ;;;AAGA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,6CAA6C;IAC7C,sCAAsC;IACtC,qCAAqC;IACrC,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;;;IAGxC;QACI,YAAY;QACZ,kBAAkB;QAClB,WAAW;QACX,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;QACnB,YAAY;QACZ,kBAAkB;QAClB,WAAW;QACX,eAAe;QACf,sBAAsB;QACtB,+BAA+B;IACnC;;IAEA;QACI,YAAY;IAChB;;AAEJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;;IAElB,gDAAgD;AACpD;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,0DAA0D;AAC9D;;AAEA;IACI,WAAW;IACX,aAAa;IACb,wBAAwB;IACxB,2BAA2B;IAC3B,yDAAsD;IACtD,4BAA4B;IAC5B,mBAAmB;;IAEnB;QACI,iBAAiB;QACjB,6BAA6B;QAC7B,kBAAkB;QAClB,SAAS;QACT,uBAAuB;QACvB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;;QAEnB;YACI,wCAAwC;YACxC,aAAa;YACb,uBAAuB;YACvB,mBAAmB;YACnB,2BAA2B;YAC3B,uBAAuB;YACvB,eAAe;;YAEf;gBACI,aAAa;gBACb,uBAAuB;gBACvB,mBAAmB;gBACnB,wCAAwC;gBACxC,0BAA0B;gBAC1B,sBAAsB;gBACtB,iCAAiC;gBACjC,gCAAgC;gBAChC,WAAW;gBACX,sBAAsB;gBACtB,eAAe;gBACf,kBAAkB;gBAClB,gBAAgB;gBAChB,iBAAiB;gBACjB,aAAa;YACjB;QACJ;IACJ;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,YAAY;QACZ,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;QAClB,kBAAkB;QAClB,cAAc;QACd,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;;IAEvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,oCAAoC;QACpC,oBAAoB;QACpB,eAAe;QACf,YAAY;QACZ,cAAc;QACd,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;QAChB,kBAAkB;QAClB,YAAY;QACZ,iBAAiB;QACjB,SAAS;QACT,sDAAsD;IAC1D;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,UAAU;QACV,aAAa;QACb,sBAAsB;QACtB,yBAAyB;QACzB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,2BAA2B;QAC3B,SAAS;IACb;AACJ;;;;;AAKA;IACI,aAAa;IACb,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,kBAAkB;;AAEtB;;AAEA;IACI;AACJ;;;AAGA,UAAU;AACV;IACI,mBAAmB;AACvB;;AAEA,WAAW;AACX;IACI,gBAAgB;AACpB;;;;;AAKA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;IACtC,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,UAAU;;AAEd;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,UAAU;AACd;;AAEA,+BAA+B;;AAE/B,8BAA8B;;AAE9B;IACI,YAAY;IACZ,kBAAkB;IAClB,gDAAgD;IAChD,oCAAoC;IACpC,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,0DAA0D;AAC9D;;AAEA;IACI,YAAY;IACZ,kDAAkD;AACtD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;;AAGA;IACI,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;IAChC,qCAAqC;IACrC,0BAA0B;IAC1B,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,gCAAgC;IAChC,WAAW;IACX,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,sCAAsC;AAC1C;;AAEA,iBAAiB;;AAEjB;IACI,YAAY;IACZ,kBAAkB;IAClB,gDAAgD;IAChD,2BAA2B;IAC3B,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,YAAY;AAChB;;AAEA,cAAc;;AAEd;;IAEI,uBAAuB;AAC3B;;AAEA,gBAAgB;;AAEhB,8CAA8C;;AAE9C;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;QACb,iBAAiB;QACjB,yBAAyB;QACzB,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,QAAQ;;QAER;YACI,oCAAoC;YACpC,oBAAoB;YACpB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;YACjB,SAAS;QACb;;QAEA;YACI,cAAc;YACd,oBAAoB;YACpB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;YACjB,SAAS;QACb;;QAEA;YACI,WAAW;YACX,UAAU;YACV,yBAAyB;YACzB,kBAAkB;QACtB;IACJ;AACJ;;;AAGA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;;IAEhB;QACI,YAAY;QACZ,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;;QAEjB;YACI,cAAc;YACd,oBAAoB;YACpB,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,iBAAiB;YACjB,SAAS;QACb;;QAEA;YACI,aAAa;YACb,mBAAmB;;YAEnB;gBACI,cAAc;gBACd,oBAAoB;gBACpB,eAAe;gBACf,kBAAkB;gBAClB,gBAAgB;gBAChB,iBAAiB;gBACjB,kBAAkB;gBAClB,aAAa;YACjB;;YAEA;gBACI,oCAAoC;gBACpC,oBAAoB;gBACpB,eAAe;gBACf,kBAAkB;gBAClB,gBAAgB;gBAChB,iBAAiB;gBACjB,SAAS;YACb;QACJ;IACJ;AACJ;;AAEA;IACI,yCAAyC;;IAEzC;QACI,2HAA2H;IAC/H;;IAEA;QACI;YACI,WAAW;QACf;;QAEA;YACI;gBACI,cAAc;YAClB;;YAEA;gBACI,yBAAyB;YAC7B;QACJ;IACJ;AACJ;;AAEA,oGAAoG;AACpG;IACI,6DAA6D;IAC7D,aAAa;IACb,cAAc;IACd,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;oFACoF;AACpF;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,8DAA8D;IAC9D,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;;;IAII,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA;;;IAGI,4BAA4B;AAChC;;AAEA,8FAA8F;AAC9F;IACI,4BAA4B;IAC5B,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA,2GAA2G;AAC3G;IACI,8DAA8D;AAClE;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,qDAAqD;IACrD,SAAS;IACT,2BAA2B;IAC3B,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;IAClB,sDAAsD;IACtD,2BAA2B;IAC3B,mCAAmC;IACnC,+DAA+D;IAC/D,mBAAmB;IACnB;8CAC0C;IAC1C,sDAAsD;AAC1D;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,cAAc;IACd,gDAAgD;IAChD,8BAA8B;IAC9B,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAClB,sDAAsD;AAC1D;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,kBAAkB;IAClB,sDAAsD;IACtD,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,qCAAqC;;IAErC;QACI,WAAW;QACX,YAAY;QACZ,sDAAsD;QACtD,cAAc;QACd,cAAc;QACd,mBAAmB;QACnB,kBAAkB;IACtB;AACJ;;AAEA;IACI,mEAAmE;IACnE,uCAAuC;AAC3C;;AAEA;IACI,uCAAuC;IACvC,yBAAyB;AAC7B;;AAEA,iFAAiF;AACjF;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8GAA8G;IAC9G,sCAAsC;IACtC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,wEAAwE;;IAExE;QACI,WAAW;QACX,YAAY;QACZ,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,cAAc;QACd,cAAc;QACd,cAAc;QACd,kBAAkB;IACtB;AACJ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,aAAa;IACb,qCAAqC;AACzC;;AAEA;;8EAE8E;AAC9E;IACI,mEAAmE;AACvE;;AAEA;;;;IAII,8GAA8G;IAC9G,cAAc;AAClB;;AAEA;;;IAGI,cAAc;IACd,kBAAkB;AACtB;;AAEA;;;;IAII,4BAA4B;AAChC;;AAEA;;IAEI,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,8CAA8C;AAClD;;AAEA;IACI,KAAK,2CAA2C,EAAE;IAClD,MAAM,0CAA0C,EAAE;IAClD,OAAO,wCAAwC,EAAE;AACrD;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB;IACJ;AACJ;;AAEA,oDAAoD;AACpD;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,SAAS;IACT,kBAAkB;AACtB;;AAEA;;gFAEgF;AAChF;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,sDAAsD;IACtD,2CAA2C;IAC3C,sBAAsB;AAC1B;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI;QACI,SAAS;QACT,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,YAA0B;QAA1B,cAA0B;QAA1B,4BAA0B;QAC1B,0BAA0B;QAC1B,QAAQ;QACR,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,8BAA8B;IAClC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":["@font-face {\n    font-family: Poppins-bold;\n    src: url(\"./components/assets/Poppins/Poppins-SemiBold.ttf\");\n}\n\n@font-face {\n    font-family: Poppins;\n    src: url(\"./components/assets/Poppins/Poppins-Regular.ttf\");\n}\n\n:root {\n    --brand-primary: #0877BC;\n    --brand-primary-dark: #065a8f;\n    --brand-primary-light: #0a8cd8;\n    --brand-secondary: #46528b;\n    --brand-accent: #FFEFDD;\n    --brand-bg: #f4f5f6;\n    --brand-surface: #FFFFFF;\n    --brand-text: #1E1E1E;\n    --brand-text-secondary: #838383;\n    --brand-font: 'Poppins', sans-serif;\n    --brand-primary-rgb: 8, 119, 188;\n\n    /* Dynamic Theme Mappings (bright / light is the default view) */\n    --bg-color: var(--brand-bg, #f3f4f6);\n    --surface-color: var(--brand-bg, #ffffff);\n    --text-color: #111827;\n    --text-secondary: #4b5563;\n    --border-color: rgba(0, 0, 0, 0.08);\n    --glass-bg: rgba(255, 255, 255, 0.85);\n    --glass-border: rgba(0, 0, 0, 0.08);\n    --shadow-color: rgba(0, 0, 0, 0.06);\n    --card-hover-shadow: rgba(8, 119, 188, 0.15);\n    --profile-hover-bg: rgba(0, 0, 0, 0.03);\n    --profile-segmented-bg: rgba(0, 0, 0, 0.08);\n    --ease-premium: cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.light-mode {\n    --bg-color: var(--brand-bg, #f3f4f6);\n    --surface-color: var(--brand-bg, #ffffff);\n    --text-color: #111827;\n    --text-secondary: #4b5563;\n    --border-color: rgba(0, 0, 0, 0.08);\n    --glass-bg: rgba(255, 255, 255, 0.85);\n    --glass-border: rgba(0, 0, 0, 0.08);\n    --shadow-color: rgba(0, 0, 0, 0.06);\n    --card-hover-shadow: rgba(8, 119, 188, 0.15);\n    --profile-hover-bg: rgba(0, 0, 0, 0.03);\n    --profile-segmented-bg: rgba(0, 0, 0, 0.08);\n}\n\n/* Premium native-like iOS Start Button interactive transitions */\n.ios-start-btn {\n    transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1), filter 0.25s ease, box-shadow 0.25s ease !important;\n}\n.ios-start-btn:hover:not(:disabled) {\n    filter: brightness(1.08);\n    transform: translateY(-1.5px);\n    box-shadow: 0 8px 22px rgba(var(--brand-primary-rgb), 0.45) !important;\n}\n.ios-start-btn:active:not(:disabled) {\n    transform: scale(0.96) translateY(0);\n    filter: brightness(0.95);\n    box-shadow: 0 4px 10px rgba(var(--brand-primary-rgb), 0.25) !important;\n}\n\n.dark-mode {\n    --bg-color: #0b0f19;\n    --surface-color: #111827;\n    --text-color: #f9fafb;\n    --text-secondary: #9ca3af;\n    --border-color: rgba(255, 255, 255, 0.08);\n    --glass-bg: rgba(17, 24, 39, 0.75);\n    --glass-border: rgba(255, 255, 255, 0.08);\n    --shadow-color: rgba(0, 0, 0, 0.3);\n    --card-hover-shadow: rgba(8, 119, 188, 0.25);\n    --profile-hover-bg: rgba(255, 255, 255, 0.05);\n    --profile-segmented-bg: rgba(255, 255, 255, 0.12);\n}\n\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    font-family: var(--brand-font);\n}\n\nbody {\n    font-family: var(--brand-font);\n    background-color: var(--bg-color);\n    color: var(--text-color);\n    transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n\n\n#adminRoot {\n    position: relative;\n    min-height: 100vh;\n    max-height: max-content;\n    display: flex;\n    flex-direction: column;\n    border-radius: 4px;\n    color: #343339;\n    margin: 0 auto;\n    padding: 0 5px;\n    /* Room for bottom nav + safe area so content is never hidden behind it */\n    padding-bottom: max(120px, calc(80px + env(safe-area-inset-bottom)));\n}\n\n#adminRoot.home-theme-root,\n#adminRoot.user-form-theme,\n#adminRoot.group-form-theme {\n    color: var(--text-color);\n    background-color: var(--bg-color);\n    transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n\n.Hero::before {\n    position: absolute;\n    content: '';\n    z-index: 0;\n    width: 100%;\n    height: 100%;\n    background-image: url(./components/assets/landing_bg_img.jpg);\n    background-size: cover;\n    background-repeat: no-repeat;\n}\n\n.rdrMonths {\n    align-items: center\n}\n\n.Hero {\n    overflow: hidden;\n    object-fit: fill;\n    width: 50%;\n    height: 100vh;\n    position: relative;\n\n    >h1 {\n        color: #FFF;\n        text-align: center;\n        font-size: 23px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 29px;\n        text-align: center;\n        position: absolute;\n        bottom: 20px;\n        margin: 0;\n        padding: 0 20px;\n    }\n}\n\n.validation_error {\n    font-size: 11px;\n    color: red;\n    margin-top: 7px;\n}\n\n.fgb-login>button {\n    width: 100%;\n}\n\n.fbg-btn {\n    >p {\n        color: var(--neutral-1, #1E1E1E);\n        text-align: center;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 24px;\n    }\n\n}\n\n.seperator {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    /* 150% */\n\n    >hr {\n        height: 1px;\n        border: none;\n        background: #D9D9D9;\n        width: 42.5vw;\n    }\n\n    >p {\n        color: var(--Gray-1, #838383);\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 24px;\n        margin: 0 1vw;\n    }\n}\n\n.hide {\n    filter: invert(44%) sepia(90%) saturate(6420%) hue-rotate(187deg) brightness(93%) contrast(94%);\n}\n\n.search-bar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px;\n}\n\n.search-bar-input {\n    width: 85%;\n    display: flex;\n    border-radius: 50px;\n    padding: 12px;\n    background: var(--surface-color);\n    border: 1px solid var(--border-color);\n    transition: all 0.3s var(--ease-premium);\n\n    &:focus-within {\n        border-color: var(--brand-primary);\n        box-shadow: 0 0 10px rgba(var(--brand-primary-rgb), 0.2);\n    }\n\n    >img {\n        margin-right: 5px;\n        opacity: 0.7;\n    }\n\n    >input {\n        background: none;\n        border: none;\n        color: var(--text-color);\n        font-family: Poppins;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 24px;\n        width: 100%;\n    }\n\n    >input:focus-visible {\n        outline: none;\n    }\n}\n\n.filter-btn {\n    background: none;\n    border-radius: 50px;\n    padding: 7px 8px;\n    border: 1px solid var(--Line, #EDEDED);\n}\n\n.filter-btn:hover {\n    opacity: .7;\n}\n\n\n.news-cards {\n    margin: 10px 3vw 0 3vw;\n}\n\n.news-card {\n    height: 178px;\n    width: 100%;\n    max-width: 370px;\n    background-size: contain;\n    border-radius: 8px;\n    border-radius: 8px;\n    position: relative;\n\n    >.news-card-info {\n        display: flex;\n        flex-direction: column;\n        justify-content: start;\n        align-items: self-start;\n        position: absolute;\n        bottom: 1vh;\n        left: 3vw;\n\n        >h3 {\n            color: #FFF;\n            /* Course Title */\n            font-family: Poppins;\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: 24px;\n            /* 150% */\n        }\n\n        >p {\n            color: #939393;\n            font-family: Poppins;\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: 24px;\n            /* 171.429% */\n        }\n    }\n}\n\n.whitespace {\n    height: 5vh;\n}\n\n.dot {\n    background-color: var(--brand-primary) !important;\n    width: 6px !important;\n    height: 6px !important;\n}\n\n.news-info {\n    margin-top: 10px;\n}\n\n\n.page-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 0;\n    height: 50px;\n    padding: 15px;\n\n    >h2 {\n        color: var(--Black, #202226);\n        font-family: Poppins;\n        font-size: 20px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 24px;\n        /* 120% */\n    }\n}\n\n.progress-cards {\n    display: flex;\n    gap: 20px;\n    padding: 15px;\n    flex-wrap: wrap;\n    align-items: stretch;\n}\n\n.progress-card {\n    position: relative;\n    height: auto;\n    min-width: 140px;\n    width: calc(50% - 10px);\n    border-radius: 16px;\n    background: var(--surface-color);\n    border: 1px solid var(--border-color);\n    box-shadow: 0px 4px 12px var(--shadow-color);\n    padding: 12px;\n    transition: transform 0.3s var(--ease-premium), box-shadow 0.3s var(--ease-premium), border-color 0.3s var(--ease-premium);\n\n    &:hover {\n        transform: translateY(-4px);\n        box-shadow: 0 10px 25px var(--card-hover-shadow);\n        border-color: var(--brand-primary);\n    }\n\n    >.progress-card-header {\n        padding: 6px;\n        display: flex;\n        justify-content: space-between;\n        align-items: start;\n\n        >h3 {\n            color: var(--text-color);\n            font-family: Poppins;\n            font-size: 11px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: 16px;\n        }\n\n        >p {\n            text-align: center;\n            font-size: 18px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 20px;\n            border-radius: 8px;\n            background: rgba(var(--brand-primary-rgb), 0.15);\n            color: var(--brand-primary);\n            height: 40px;\n            min-width: 40px;\n            justify-content: center;\n            display: flex;\n            align-items: center;\n        }\n    }\n\n    >img {\n        display: flex;\n        margin: auto;\n        margin-bottom: 17px;\n    }\n\n}\n\n.progress-card-data {\n    >h3 {\n        color: var(--text-color);\n        font-family: Poppins-bold;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 24px;\n    }\n\n    >p {\n        color: var(--text-secondary);\n        font-family: Poppins-bold;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 24px;\n    }\n}\n\n.progress-card-data-center {\n    width: 50px;\n    position: absolute;\n    top: 50%;\n    left: 31%;\n    text-align: center;\n}\n\n.progress-card-data-uncenter {\n    margin: 17px 6px;\n    display: flex;\n    /* justify-content: baseline; */\n    align-items: baseline;\n}\n\n\n\n.exercise-procedure-service-h3 {\n    color: var(--Primary-Color, #0877BC);\n    font-family: Poppins;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n    /* 120% */\n}\n\n.exercise-procedure-service {\n    width: 100%;\n    height: 260px;\n    background-size: contain;\n    background-position: center;\n    background-image: url(\"./components/assets/table.png\");\n    background-repeat: no-repeat;\n    background-position-y: -24px;\n    margin-bottom: 40px;\n\n    >h3 {\n        color: var(--Primary-Color, #0877BC);\n        font-family: Poppins;\n        font-size: 20px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 24px;\n        /* 120% */\n    }\n\n    >.tabletop-sections {\n        perspective: 50px;\n        perspective-origin: top right;\n        position: relative;\n        top: 65px;\n        left: max(-15vw, -22px);\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        >div {\n            transform: rotateX(10deg) rotateZ(11deg);\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            flex-direction: row-reverse;\n            width: min(50vw, 129px);\n            flex-wrap: wrap;\n\n            >div {\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                background-color: var(--brand-secondary);\n                width: min(16.667vw, 43px);\n                height: min(18px, 7vw);\n                border-bottom: #919191 .5px solid;\n                border-right: #919191 .5px solid;\n                color: #FFF;\n                font-family: 'Poppins';\n                font-size: 13px;\n                font-style: normal;\n                font-weight: 600;\n                line-height: 24px;\n                /* 184.615% */\n            }\n        }\n    }\n}\n\n\n.exercise-details {\n    display: flex;\n    justify-content: start;\n    padding: 15px;\n    gap: 40px;\n\n    >.edit-exercise-objective {\n        >textarea {\n            width: 100%;\n            height: 80px;\n            color: var(--Gray-1, #838383);\n            font-family: Poppins;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 18px;\n            /* 150% */\n        }\n\n        >p {\n            color: var(--Gray-1, #838383);\n            font-family: Poppins;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 18px;\n            /* 150% */\n        }\n\n        >div {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n\n            >span {\n                margin-right: 3px;\n                color: var(--Primary-Color, #0877BC);\n                font-family: Poppins;\n                font-size: 14px;\n                font-style: normal;\n                font-weight: 600;\n                line-height: 24px;\n                /* 171.429% */\n            }\n\n            >img {\n                height: 20px;\n                filter: brightness(0) saturate(100%) invert(26%) sepia(99%) saturate(1569%) hue-rotate(183deg) brightness(99%) contrast(94%);\n            }\n        }\n    }\n\n    >.exercise-details-show,\n    >.exercise-details-edit {\n        display: flex;\n        flex-direction: column;\n        gap: 7px;\n\n        >span {\n            color: var(--Primary-Color, #0877BC);\n            font-family: Poppins;\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: 24px;\n            /* 171.429% */\n        }\n\n        >p {\n            color: var(--Gray-1, #838383);\n            font-family: Poppins;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 24px;\n            /* 200% */\n        }\n\n        >select {\n            border: none;\n            border-radius: 3px;\n            background: rgba(var(--brand-primary-rgb), 0.17);\n            color: var(--Primary-Color, #0877BC);\n            font-family: Poppins;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 24px;\n            /* 200% */\n        }\n    }\n}\n\n.exercise-details-skills {\n    padding: 0 15px;\n\n    >div {\n        >span {\n            color: var(--Primary-Color, #0877BC);\n            font-family: Poppins;\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: 24px;\n            /* 171.429% */\n        }\n    }\n\n    >.add-skill {\n        display: flex;\n        justify-content: start;\n        align-items: center;\n        margin-top: 10px;\n\n        >input {\n            height: 28px;\n            border-radius: 4px;\n            border: none;\n            margin-right: 5px;\n            padding: 7px;\n            background: rgba(var(--brand-primary-rgb), 0.17);\n            color: var(--Primary-Color, #0877BC);\n            font-family: Poppins;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 24px;\n            /* 200% */\n        }\n\n        >input:focus-visible {\n            outline: 1px cadetblue;\n        }\n\n        >button {\n            border: none;\n            border-radius: 4px;\n            padding: 0 7px;\n            background-color: rgba(var(--brand-primary-rgb), 0.17);\n            color: var(--Primary-Color, #0877BC);\n            font-family: Poppins;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 24px;\n            /* 200% */\n        }\n    }\n}\n\n.exercise-details-skill-names {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin-top: 10px;\n\n    >p {\n        position: relative;\n        color: var(--Primary-Color, #0877BC);\n        font-family: Poppins;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 24px;\n        padding: 2px 7px;\n        border-radius: 4px;\n        background: var(--Primary-Color, #0877bc2d);\n        /* 200% */\n\n        >span {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            position: absolute;\n            top: -8px;\n            right: -5px;\n            height: 15px;\n            width: 15px;\n            border-radius: 8px;\n            color: #FFF;\n            background-color: var(--brand-primary);\n        }\n    }\n}\n\n.exercise-focus-points {\n    display: flex;\n    flex-direction: column;\n    margin: 20px 0;\n    gap: 7px;\n    padding: 0 15px;\n\n    >.edit-focus {\n        display: flex;\n        align-items: baseline;\n\n        >h3 {\n            color: #000;\n            font-family: Poppins;\n            font-size: 20px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: 24px;\n            margin-bottom: 10px;\n        }\n\n        >img {\n            height: 20px;\n            filter: brightness(0) saturate(100%) invert(26%) sepia(99%) saturate(1569%) hue-rotate(183deg) brightness(99%) contrast(94%);\n        }\n    }\n\n    >h3 {\n        color: #000;\n        font-family: Poppins;\n        font-size: 20px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 24px;\n        margin-bottom: 10px;\n        /* 120% */\n    }\n\n    >div {\n        display: flex;\n        gap: 6px;\n        align-items: first baseline;\n\n        >span {\n            height: 6px;\n            flex-shrink: 0;\n            width: 6px;\n            border-radius: 12px;\n            background-color: var(--brand-primary);\n        }\n\n        >p {\n            color: var(--Gray-1, #838383);\n            font-family: Poppins;\n            font-size: 11px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 16px;\n            /* 145.455% */\n        }\n\n        >input {\n            width: 100%;\n        }\n\n        >input:focus-visible {\n            outline: none;\n        }\n    }\n}\n\n.exercise-procedure {\n    padding: 15px;\n\n    >h3 {\n        color: #000;\n        font-family: Poppins;\n        font-size: 20px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 24px;\n        /* 120% */\n        margin-bottom: 40px;\n    }\n}\n\n.shot-details {\n    display: flex;\n    flex-wrap: wrap;\n    position: relative;\n    bottom: -135px;\n    justify-content: space-between;\n\n    >div {\n        display: flex;\n        flex-direction: column;\n\n        >span {\n            color: var(--Primary-Color, #0877BC);\n            font-family: Poppins;\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: 24px;\n            /* 171.429% */\n        }\n\n        >p {\n            color: var(--Gray-1, #838383);\n            font-family: Poppins;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 24px;\n            /* 200% */\n        }\n\n        >select {\n            border: none;\n            border-radius: 3px;\n            background: rgba(var(--brand-primary-rgb), 0.17);\n            color: var(--Primary-Color, #0877BC);\n            font-family: Poppins;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 24px;\n            /* 200% */\n        }\n    }\n}\n\n.tabletop-section-active {\n    background-color: rgb(155, 75, 138) !important;\n}\n\na {\n    text-decoration: none;\n}\n\n.exercise-started {\n    >video {\n        margin: 0 3vw;\n        width: 100%;\n        border-radius: 8px;\n    }\n}\n\n.exercise-header-white {\n    margin: 20px 3vw;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    >h2 {\n        color: #ffffff;\n        font-family: Poppins-bold;\n        font-size: 20px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 24px;\n        /* 120% */\n    }\n\n    >button {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border: none;\n        height: 45px;\n        width: 45px;\n        border-radius: 50px;\n        border: 1px solid var(--Line, #ffffff);\n    }\n\n    >button:hover {\n        opacity: .7;\n        box-shadow: 0px 5px 10px 0px rgba(234, 240, 246, 0.60);\n    }\n\n    >.back-btn {\n        background-color: #0877bc00;\n\n        >img {\n            filter: brightness(0) saturate(100%) invert(100%) sepia(2%) saturate(0%) hue-rotate(135deg) brightness(104%) contrast(102%);\n        }\n    }\n\n    >.fav-btn {\n        background: none;\n\n        >img {\n            filter: brightness(0) saturate(100%) invert(100%) sepia(2%) saturate(0%) hue-rotate(135deg) brightness(104%) contrast(102%);\n        }\n    }\n}\n\n.exercise-page-details {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n\n    >button {\n        gap: 5px;\n        background: none;\n        border: none;\n        display: flex;\n        /* justify-content: baseline; */\n        align-items: center;\n        margin: 8px 3vw;\n        color: var(--Gray-1, #838383);\n        font-family: Poppins;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 24px;\n        /* 171.429% */\n        text-decoration-line: underline;\n    }\n\n    .button {\n        width: 90%;\n        background-color: var(--brand-primary);\n        color: var(--White, #FFF);\n        text-align: center;\n        margin: 10px auto;\n        height: 45px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 8px;\n        font-family: Poppins;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 24px;\n        /* 150% */\n    }\n}\n\n.exercise-name {\n    /* overflow: hidden; */\n    overflow-x: hidden;\n    margin: 10px 3vw;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    /* margin-top: 10px; */\n\n        >button {\n        background: none;\n        border: none;\n        width: 35px;\n        height: 35px;\n        border-radius: 50px;\n        background: rgba(var(--brand-primary-rgb), 0.20);\n    }\n\n    >h3 {\n        color: var(--Primary-Color, #0877BC);\n\n        /* Heading */\n        font-family: Poppins;\n        font-size: 20px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 28px;\n        /* 140% */\n    }\n}\n\n.exercise-step-info {\n    color: var(--Gray-1, #838383);\n    margin: 0 3vw;\n    /* Body/Regular */\n    font-family: Poppins;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n    /* 171.429% */\n}\n\n.exercise-timer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n}\n\n.timer-clock {\n    color: var(--Black, #202226);\n    text-align: center;\n    font-family: Poppins-bold;\n    font-size: 35px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 46px;\n    /* 131.429% */\n}\n\n.timer-actions {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin: 100px;\n\n    >button {\n        background: none;\n        border: none;\n    }\n\n    >button:disabled {\n        cursor: not-allowed;\n    }\n}\n\n.pause-play {\n\n\n\n    >img {\n        cursor: pointer;\n        width: 35px;\n        filter: brightness(0) saturate(100%) invert(26%) sepia(98%) saturate(1262%) hue-rotate(180deg) brightness(104%) contrast(94%);\n    }\n\n}\n\n.feedback-input {\n    margin-top: 10px;\n\n    h4 {\n        color: var(--Black, #202226);\n        font-family: Poppins;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 28px;\n        /* 175% */\n    }\n}\n\n.feedback-input-options {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n    margin: 17px 0;\n}\n\n.feedback-input-option {\n    border-radius: 8px;\n    background: #FFF;\n    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.13);\n    width: 100px;\n    height: 81px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    >p {\n        color: #202226;\n        text-align: center;\n        font-family: Poppins;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n    }\n}\n\n.feedback-input-option.selected {\n    background: var(--Primary-Color, #0877BC);\n\n    >p {\n        color: #FFF;\n    }\n}\n\n\n.add-exercise {\n    padding: 25px 30px;\n    width: 50%;\n    max-width: 100%;\n    margin: auto;\n    border-radius: 16px;\n    box-shadow: 0px 10px 30px var(--shadow-color);\n    background-color: var(--surface-color);\n    border: 1px solid var(--border-color);\n    box-sizing: border-box;\n    overflow-x: hidden;\n    transition: all 0.3s var(--ease-premium);\n\n\n    >button {\n        height: 45px;\n        margin-bottom: 3vw;\n        color: #FFF;\n        font-family: Poppins;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n        border: none;\n        border-radius: 8px;\n        width: 100%;\n        max-width: 100%;\n        box-sizing: border-box;\n        /* background-color: #0877BC; */\n    }\n\n    >button:hover {\n        opacity: 0.7;\n    }\n\n}\n\n.input {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: transparent;\n    background: none;\n    border-radius: 7px;\n    /* opacity: 0.1; */\n\n    background: rgba(var(--brand-primary-rgb), 0.09);\n}\n\n.input::-webkit-file-upload-button {\n    visibility: hidden;\n}\n\n\n.input:hover::before {\n    border-color: black;\n}\n\n.input:active {\n    outline: 0;\n}\n\n.input:active::before {\n    background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);\n}\n\n.exercise-procedure-add {\n    width: 100%;\n    height: 260px;\n    background-size: contain;\n    background-position: center;\n    background-image: url(\"./components/assets/table.png\");\n    background-repeat: no-repeat;\n    margin-bottom: 40px;\n\n    >.tabletop-sections {\n        perspective: 50px;\n        perspective-origin: top right;\n        position: relative;\n        top: 65px;\n        left: max(-15vw, -22px);\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        >div {\n            transform: rotateX(10deg) rotateZ(11deg);\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            flex-direction: row-reverse;\n            width: min(50vw, 129px);\n            flex-wrap: wrap;\n\n            >div {\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                background-color: var(--brand-secondary);\n                width: min(16.667vw, 43px);\n                height: min(18px, 7vw);\n                border-bottom: #919191 .5px solid;\n                border-right: #919191 .5px solid;\n                color: #FFF;\n                font-family: 'Poppins';\n                font-size: 13px;\n                font-style: normal;\n                font-weight: 600;\n                line-height: 24px;\n                /* 184.615% */\n            }\n        }\n    }\n}\n\n.uploaded-picture {\n    height: 260px;\n    object-fit: contain;\n}\n\n.thumbs-wrapper {\n    display: none;\n}\n\n.add-skill {\n    >input {\n        height: 30px;\n        border: none;\n        background-color: #F7F7F7;\n        padding: 10px 10px;\n        border-radius: 8px;\n        color: #404145;\n        font-family: Poppins;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n\n    }\n\n    >input:focus-visible {\n        outline: none;\n    }\n\n    >button {\n        color: var(--Primary-Color, #0877BC);\n        font-family: Poppins;\n        font-size: 12px;\n        height: 30px;\n        padding: 0 7px;\n        margin-left: 10px;\n        font-style: normal;\n        font-weight: 400;\n        border-radius: 4px;\n        border: none;\n        line-height: 24px;\n        /* 200% */\n        background-color: rgba(var(--brand-primary-rgb), 0.09);\n    }\n}\n\n.input-detail {\n    button.w-100 {\n        width: 100%;\n    }\n\n    .skills-box {\n        width: 80%;\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-end;\n        align-items: end;\n    }\n\n    .skills-checkbox {\n        display: flex;\n        justify-content: flex-start;\n        gap: 10px;\n    }\n}\n\n\n\n\n#feedback {\n    padding: 15px;\n    display: flex;\n    gap: 10px;\n    flex-direction: column;\n    position: fixed;\n    bottom: 0px;\n    width: calc(60% - 30px);\n    z-index: 100000000;\n    background-color: #f4f5f6;\n}\n\n#feedback input {\n    height: 40px;\n    width: 100%;\n    border-radius: 25px;\n    padding: 15px;\n    background-color: #fff;\n}\n\n#feedback .microphone {\n    background: var(--brand-primary);\n    width: 42px;\n    height: 35px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n}\n\n#feedback svg {\n    color: #FFFFFF;\n}\n\n.audio-recorder {\n    background: var(--brand-primary) !important;\n}\n\n#comments {\n    width: 100%;\n    padding: 15px;\n    height: 70vh;\n    overflow-y: scroll;\n\n}\n\n#comments::-webkit-scrollbar {\n    width: 3px\n}\n\n\n/* Track */\n#comments::-webkit-scrollbar-track {\n    background: #f1f1f1;\n}\n\n/* Handle */\n#comments::-webkit-scrollbar-thumb {\n    background: #888;\n}\n\n\n\n\n#comments ul li .audioFeedback {\n    width: 50%;\n}\n\n.author div {\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    border: 1px solid var(--brand-primary);\n    background-color: #ccc;\n    color: var(--brand-primary);\n    text-align: center;\n    padding: 0;\n\n}\n\n.author img {\n    width: 30px;\n    border-radius: 50%;\n}\n\n#saveChanges {\n    padding: 0 15px;\n    width: 100%;\n}\n\n#saveChanges button,\n#saveChanges a {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 59px;\n    border: none;\n    color: var(--White, #FFF);\n    text-align: center;\n    leading-trim: both;\n    text-edge: cap;\n    font-family: Poppins;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n    border-radius: 12px;\n    background: var(--Primary-Color, #0877BC);\n    margin-bottom: 15px;\n    width: 100%;\n}\n\n.session-setup {\n    padding: 0 15px;\n}\n\n.session-setup ul {\n    list-style-type: none;\n    display: flex;\n    flex-direction: column;\n}\n\n.session-setup ul li {\n    display: flex;\n    border: 1px solid #e3e3e3;\n    border-radius: 8px;\n    margin-bottom: 10px;\n    padding: 8px;\n    gap: 15px;\n}\n\n.session-setup ul li .image {\n    width: 50px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.session-setup ul li .image img {\n    width: 100%;\n}\n\n.session-setup ul li .info {\n    font-size: 14px;\n    width: 60%;\n}\n\n.session-setup ul li .info h5 {}\n\n.session-setup ul li .info p {}\n\n.session-setup ul li select {\n    border: none;\n    border-radius: 3px;\n    background: rgba(var(--brand-primary-rgb), 0.17);\n    color: var(--Primary-Color, #0877BC);\n    font-family: Poppins;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n    width: 100%;\n}\n\n\n#rating {\n    padding: 15px;\n}\n\n#rating h1 {\n    font-size: 16px;\n    padding: 0;\n    margin: 0;\n    font-family: Poppins-bold;\n}\n\n#rating ul {\n    list-style-type: none;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 15px;\n    margin-top: 15px;\n}\n\n#rating ul li {\n    width: 33%;\n    height: 100px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);\n    border-radius: 8px;\n    position: relative;\n}\n\n#rating ul li input[type=\"radio\"] {\n    display: none;\n}\n\n#rating ul li label {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 8px;\n}\n\n#rating ul li input[type=\"radio\"]:checked+label {\n    background: #0877BC;\n    /* Change the border color to indicate the checked state */\n}\n\n#rating ul li input[type=\"radio\"]:checked+label img {\n    opacity: 0.8;\n    /* Slightly fade the image for the checked state */\n}\n\n#rating ul li img {\n    width: 65px;\n}\n\n#wavePlayerBtn {\n    position: absolute;\n    top: 30px;\n    left: -45px;\n    width: 40px;\n    height: 40px;\n    background: #000;\n    border: 0;\n    border-radius: 50%;\n}\n\n#wavePlayerBtn svg {\n    color: #FFFFFF;\n    width: 20px;\n    height: 20px;\n}\n\n#dashLink {\n    border: 1px solid #e3e3e3;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 505%;\n    width: 41px;\n    height: 42px;\n    padding: 10px;\n}\n\n\n#selectedSessionDays {\n    list-style-type: none;\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    width: 100%;\n    flex-wrap: wrap;\n}\n\n#selectedSessionDays button {\n    position: relative;\n    color: var(--text-color);\n    font-family: Poppins;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n    padding: 4px 12px;\n    border-radius: 8px;\n    background: var(--surface-color);\n    border: 1px solid var(--border-color);\n    text-transform: capitalize;\n    margin-bottom: 10px;\n    transition: all 0.2s var(--ease-premium);\n}\n\n#selectedSessionDays button:hover {\n    background: var(--brand-primary);\n    color: #fff;\n    border-color: var(--brand-primary-light);\n}\n\n#selectedSessionDays span {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: -8px;\n    right: -5px;\n    height: 15px;\n    width: 15px;\n    border-radius: 8px;\n    color: #FFF;\n    background-color: var(--brand-primary);\n}\n\n.sessionPlayers {}\n\n.sessionPlayers select {\n    border: none;\n    border-radius: 3px;\n    background: rgba(var(--brand-primary-rgb), 0.17);\n    color: var(--brand-primary);\n    font-family: Poppins;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n    width: 35%;\n    height: 25px;\n}\n\n#permissions {}\n\n#permissions th,\n#permissions td {\n    padding: 8px !important;\n}\n\n#timerAbsolute {}\n\n/* --------------not use-------------------- */\n\n.training-cards {\n    display: flex;\n    overflow-x: auto;\n    overflow-y: auto;\n    margin: 10px 3vw;\n    gap: 12px;\n}\n\n.training-card {\n    >img {\n        width: 240px;\n        height: 160px;\n        object-fit: cover;\n        object-position: 100% 50%;\n        border-radius: 8px;\n    }\n\n    >h3 {\n        color: #0A0615;\n        font-family: Poppins;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: 20px;\n        /* 125% */\n    }\n\n    >.training-card-info {\n        display: flex;\n        align-items: center;\n        gap: 6px;\n\n        >.training-card-info-datetime {\n            color: var(--Primary-Color, #0877BC);\n            font-family: Poppins;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: 24px;\n            /* 200% */\n        }\n\n        >.training-card-info-duration {\n            color: #404B52;\n            font-family: Poppins;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 18px;\n            /* 150% */\n        }\n\n        >span {\n            height: 4px;\n            width: 4px;\n            background-color: #404B52;\n            border-radius: 4px;\n        }\n    }\n}\n\n\n.other-training-card {\n    display: flex;\n    /* justify-content: center; */\n    align-items: center;\n    margin: 0 3vw 16px 3vw;\n    height: 80px;\n    padding: 8px;\n    border-radius: 8px;\n    border: 1px solid #E5E9EF;\n    background: #FFF;\n\n    >.other-training-card-img {\n        height: 64px;\n        width: 64px;\n        border-radius: 8px;\n    }\n\n    >.other-training-card-info-svg {\n        margin-left: auto;\n    }\n\n    .other-training-card-info {\n        margin-left: 10px;\n\n        >h3 {\n            color: #0A0615;\n            font-family: Poppins;\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: 20px;\n            /* 125% */\n        }\n\n        >div {\n            display: flex;\n            align-items: center;\n\n            >.duration {\n                color: #404B52;\n                font-family: Poppins;\n                font-size: 14px;\n                font-style: normal;\n                font-weight: 400;\n                line-height: 24px;\n                margin-right: 10px;\n                /* 171.429% */\n            }\n\n            >.datetime {\n                color: var(--Primary-Color, #0877BC);\n                font-family: Poppins;\n                font-size: 12px;\n                font-style: normal;\n                font-weight: 500;\n                line-height: 24px;\n                /* 200% */\n            }\n        }\n    }\n}\n\n.other-training-card:hover {\n    background: var(--Primary-Color, #0877BC);\n\n    >.other-training-card-info-svg {\n        filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(317deg) brightness(103%) contrast(102%);\n    }\n\n    .other-training-card-info {\n        >h3 {\n            color: #FFF;\n        }\n\n        >div {\n            >.duration {\n                color: #D2D2D2;\n            }\n\n            >.datetime {\n                color: var(--White, #FFF);\n            }\n        }\n    }\n}\n\n/* Wrapper for pages under bottom nav: reserve space so content is not hidden behind the fixed bar */\n.main-content-with-bottom-nav {\n    padding-bottom: calc(96px + env(safe-area-inset-bottom, 0px));\n    min-height: 0;\n    display: block;\n    width: 100%;\n    max-width: 100%;\n    overflow-x: clip;\n    box-sizing: border-box;\n}\n\n/* Admin dashboard shell scrolls inside #content at 100vh — padding on the outer\n   wrapper alone is not enough; clear the floating bottom nav inside the scroller. */\n.main-content-with-bottom-nav #content {\n    height: 100dvh;\n    max-height: 100dvh;\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    overflow-x: hidden;\n    overflow-y: auto;\n    padding-bottom: calc(132px + env(safe-area-inset-bottom, 0px));\n    box-sizing: border-box;\n    -webkit-overflow-scrolling: touch;\n}\n\n.main-content-with-bottom-nav #dashboard.admin-theme-root {\n    min-height: 0;\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    overflow-x: clip;\n}\n\nhtml.lt-route-active .bottom-nav,\nhtml.lt-immersive .bottom-nav,\nhtml.lt-player-live .bottom-nav,\nhtml.cm-immersive .bottom-nav {\n    display: none !important;\n    pointer-events: none;\n}\n\nhtml.lt-route-active .main-content-with-bottom-nav,\nhtml.lt-immersive .main-content-with-bottom-nav,\nhtml.cm-immersive .main-content-with-bottom-nav {\n    padding-bottom: 0 !important;\n}\n\n/* Single bottom inset for shell pages — avoid stacking with #adminRoot / home-theme offsets */\n.main-content-with-bottom-nav #adminRoot {\n    padding-bottom: 0 !important;\n    min-height: 0 !important;\n    max-height: none;\n}\n\n.main-content-with-bottom-nav .home-theme-root {\n    min-height: 0 !important;\n    padding-bottom: 0 !important;\n}\n\nhtml.app-bottom-nav-shell,\nhtml.app-bottom-nav-shell body {\n    overscroll-behavior-y: none;\n}\n\n/* Extra bottom space for exercise list pages (SelectExerciseType, etc.) so last items stay above the nav */\n.main-content-with-bottom-nav .exercise_session_div {\n    padding-bottom: calc(100px + env(safe-area-inset-bottom, 0px));\n}\n\n.bottom-nav {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    position: fixed;\n    z-index: 999;\n    bottom: calc(16px + env(safe-area-inset-bottom, 0px));\n    left: 50%;\n    transform: translateX(-50%);\n    width: calc(100% - 32px);\n    max-width: 440px;\n    padding: 10px 18px;\n    background: var(--glass-bg, rgba(255, 255, 255, 0.76));\n    backdrop-filter: blur(20px);\n    -webkit-backdrop-filter: blur(20px);\n    border: 1px solid var(--border-color, rgba(255, 255, 255, 0.5));\n    border-radius: 24px;\n    box-shadow: 0 12px 36px var(--shadow-color, rgba(0, 0, 0, 0.12)), \n                0 4px 12px rgba(0, 0, 0, 0.04);\n    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.bottom-nav:has(> :nth-child(6)) {\n    padding: 10px 12px;\n    gap: 2px;\n}\n\n.bottom-nav-icon-mask {\n    display: block;\n    width: 22px;\n    height: 22px;\n    margin: 0 auto;\n    background-color: var(--text-secondary, #838383);\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    -webkit-mask-size: contain;\n    mask-repeat: no-repeat;\n    mask-position: center;\n    mask-size: contain;\n    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.bottom-nav-link {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    border-radius: 50%;\n    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n    width: 44px;\n    height: 44px;\n    text-align: center;\n    box-sizing: border-box;\n    color: var(--text-secondary, #4b5563);\n\n    >svg {\n        width: 22px;\n        height: 22px;\n        transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n        display: block;\n        margin: 0 auto;\n        color: currentColor;\n        fill: currentColor;\n    }\n}\n\n.bottom-nav-link:hover {\n    background-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.06);\n    transform: translateY(-4px) scale(1.05);\n}\n\n.bottom-nav-link:active {\n    transform: translateY(-1px) scale(0.95);\n    transition: all 0.1s ease;\n}\n\n/* Active tab style - sleek brand-colored pill with a gorgeous drop shadow glow */\n.bottom-nav-link.active,\n.bottom-nav>.active {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: linear-gradient(135deg, var(--brand-primary, #0877BC) 0%, var(--brand-primary-dark, #065a8f) 100%);\n    transform: translateY(-6px) scale(1.1);\n    border-radius: 50%;\n    width: 48px;\n    height: 48px;\n    padding: 0;\n    text-align: center;\n    box-sizing: border-box;\n    color: #ffffff;\n    box-shadow: 0 8px 20px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);\n\n    > .bottom-nav-icon-mask {\n        width: 24px;\n        height: 24px;\n        background-color: #ffffff;\n    }\n\n    >svg {\n        width: 24px;\n        height: 24px;\n        display: block;\n        margin: 0 auto;\n        color: #ffffff;\n        fill: currentColor;\n    }\n}\n\n.bottom-nav > button.bottom-nav-link {\n    appearance: none;\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    font: inherit;\n    color: var(--text-secondary, #4b5563);\n}\n\n/* Button tabs (dashboard gear, live training) share .bottom-nav-link, but this\n   reset is more specific than .bottom-nav-link.active. Without the override the\n   selected gear stays white on the glass bar and disappears in bright mode. */\n.bottom-nav > button.bottom-nav-link:hover:not(.active) {\n    background-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.06);\n}\n\n.bottom-nav > button.bottom-nav-link.active,\n.bottom-nav > button.bottom-nav-link.active:hover,\nhtml.light-mode .bottom-nav > button.bottom-nav-link.active,\nhtml.dark-mode .bottom-nav > button.bottom-nav-link.active {\n    background: linear-gradient(135deg, var(--brand-primary, #0877BC) 0%, var(--brand-primary-dark, #065a8f) 100%);\n    color: #ffffff;\n}\n\n.bottom-nav > button.bottom-nav-link.active > svg,\nhtml.light-mode .bottom-nav > button.bottom-nav-link.active > svg,\nhtml.dark-mode .bottom-nav > button.bottom-nav-link.active > svg {\n    color: #ffffff;\n    fill: currentColor;\n}\n\nhtml.light-mode .bottom-nav-link,\nhtml.dark-mode .bottom-nav-link,\nhtml.light-mode .bottom-nav > button.bottom-nav-link:not(.active),\nhtml.dark-mode .bottom-nav > button.bottom-nav-link:not(.active) {\n    color: var(--text-secondary);\n}\n\nhtml.light-mode .bottom-nav-icon-mask,\nhtml.dark-mode .bottom-nav-icon-mask {\n    background-color: var(--text-secondary);\n}\n\n.bottom-nav-link--live {\n    position: relative;\n}\n\n.bottom-nav-live-dot {\n    position: absolute;\n    top: 7px;\n    right: 7px;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: #22c55e;\n    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55);\n    animation: lt-nav-pulse 1.6s ease-out infinite;\n}\n\n@keyframes lt-nav-pulse {\n    0% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55); }\n    70% { box-shadow: 0 0 0 8px rgba(34, 197, 94, 0); }\n    100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }\n}\n\n.bottom-nav-link--live:disabled {\n    opacity: 0.55;\n    cursor: wait;\n}\n\n@media(max-width:1250px) {\n    #feedback {\n        width: calc(50% - 30px);\n    }\n}\n\n@media(max-width:900px) {\n    .Hero {\n        width: 100%;\n    }\n}\n\n@media(max-width:720px) {\n    #feedback {\n        background-color: #f4f5f6;\n        width: 100%\n    }\n}\n\n/* Add Exercise / Use Template row - fit on mobile */\n.exercise-add-buttons-row {\n    padding: 0 5px;\n    box-sizing: border-box;\n}\n\n.exercise-add-buttons-row .exercise-add-btn {\n    box-sizing: border-box;\n    overflow: hidden;\n    gap: 12px;\n    padding: 10px 12px;\n}\n\n/* Keep text inside button - shrink text area, not icon.\n   Parent row uses brand primary/secondary as full button bg; icon well must not\n   stay fixed blue (Session.css .session-image-add) — use frosted chip on top. */\n.exercise-add-buttons-row .exercise-add-btn .session-image-add {\n    flex-shrink: 0;\n    width: 44px;\n    min-width: 44px;\n    background-color: rgba(255, 255, 255, 0.22) !important;\n    border: 2px solid rgba(255, 255, 255, 0.38);\n    box-sizing: border-box;\n}\n\n.exercise-add-buttons-row .exercise-add-btn .session-addinfo {\n    flex: 1;\n    min-width: 0;\n    overflow: hidden;\n    padding-right: 0;\n}\n\n.exercise-add-buttons-row .exercise-add-btn .session-addinfo h3 {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 14px;\n    line-height: 1.2;\n    margin: 0;\n}\n\n@media (max-width: 480px) {\n    .exercise-add-buttons-row {\n        gap: 10px;\n        padding: 0 8px;\n        margin-bottom: 16px;\n    }\n\n    .exercise-add-buttons-row .exercise-add-btn {\n        min-width: 0;\n        flex: 1 1 calc(50% - 10px);\n        max-width: calc(50% - 5px);\n        gap: 8px;\n        padding: 8px 10px;\n    }\n\n    .exercise-add-buttons-row .exercise-add-btn .session-addinfo h3 {\n        font-size: 12px;\n    }\n}\n\n@media(max-width:500px) {\n    .bottom-nav {\n        justify-content: space-between;\n    }\n\n    .session-setup {\n        padding: 0 10px;\n    }\n\n    .add-exercise {\n        width: 100%\n    }\n\n    .progress-card {\n        width: 100% !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
